import { Button, styled } from "@mui/material";

const _Button = styled(Button)`
	&& {
		border-radius: ${(props) => props.theme.spacing(1)};
		font-weight: normal;
		padding: 10px 24px;
		font-size: 16px;
		border-width: 2px;
		box-shadow: none;
		height: 48px;
`;

export const FullWidthButton = styled(_Button)`
	width: 100%;
	max-width: 400px;
	align-self: center;
`;

export default _Button;
